import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import SectionHeroBanner from "../components/Common/SectionHeroBanner";
import MainTitle from "../components/Common/MainTitle";

const blocks = [
  {
    title: "Rig types & operating environments",
    bullets: ["Jack-up and platform rig campaigns", "Onshore desert and coastal mobilisations", "High-spec rig upgrades and 7th generation readiness"],
  },
  {
    title: "Equipment portfolio",
    bullets: ["Nitrogen pumping and well intervention spreads", "Mobile pumping and steaming units", "Power generation and duel-fuel packages"],
    link: "/service/nitrogen-pumping-unit-services",
  },
  {
    title: "Technology & systems",
    bullets: ["Predictive maintenance routines", "Digital work packs and KPI dashboards", "Vendor-managed spares for critical path equipment"],
  },
];

const EquipmentTechnology = () => (
  <Fragment>
    <MetaTags>
      <title>Equipment & Technology | South Asia Consultancy</title>
      <meta
        name="description"
        content="Rig types, oilfield equipment portfolio, and technology-enabled maintenance from South Asia Consultancy."
      />
    </MetaTags>
    <LayoutOne>
      <SectionHeroBanner title="Equipment & Technology" className="sectionProjectBg" />
      <div className="container py-5 sac-page-shell">
        <MainTitle text="Capability Depth" className="text-center" position="center" width="200px" />
        <p className="text-center fs18px fw500 mb-5 sac-intro">
          We align crews, maintenance disciplines, and equipment packages so campaigns launch cleanly and stay productive in the field.
        </p>
        <div className="row">
          {blocks.map((b) => (
            <div key={b.title} className="col-md-4 mb-4">
              <div className="sac-content-card h-100">
                <h2 className="MainTitle" style={{ fontSize: "20px" }}>
                  {b.title}
                </h2>
                <ul className="fs16px lnh-28">
                  {b.bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                {b.link && (
                  <Link to={b.link} className="color-primary read-more-underline fw600">
                    View related service
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </LayoutOne>
  </Fragment>
);

export default EquipmentTechnology;
